import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'

const Veranstaltung = lazy(() => import('./pages/Veranstaltung'))
const Veranstaltungen = lazy(() => import('./pages/Veranstaltungen'))
const Raeume = lazy(() => import('./pages/Raeume'))
const RaumDetail = lazy(() => import('./pages/RaumDetail'))
const Kontakt = lazy(() => import('./pages/Kontakt'))
const Partys = lazy(() => import('./pages/Partys'))
const EventDetail = lazy(() => import('./pages/EventDetail'))
const PartysKarneval = lazy(() => import('./pages/PartysKarneval'))
const Galerie = lazy(() => import('./pages/Galerie'))
const Geschichte = lazy(() => import('./pages/Geschichte'))
const BuffetsAngebote = lazy(() => import('./pages/BuffetsAngebote'))
const Foodtruck = lazy(() => import('./pages/Foodtruck'))
const Jobs = lazy(() => import('./pages/Jobs'))
const Impressum = lazy(() => import('./pages/Impressum'))
const Datenschutz = lazy(() => import('./pages/Datenschutz'))
const Hochzeiten = lazy(() => import('./pages/Hochzeiten'))
const Unternehmensfeiern = lazy(() => import('./pages/Unternehmensfeiern'))
const PrivateFeiern = lazy(() => import('./pages/PrivateFeiern'))
const Brunch = lazy(() => import('./pages/Brunch'))
const BrunchDetail = lazy(() => import('./pages/BrunchDetail'))
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'))
const DashboardLogin = lazy(() => import('./pages/Dashboard/Login'))
const NotFound = lazy(() => import('./pages/NotFound'))

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="veranstaltung" element={<Veranstaltung />} />
        <Route path="veranstaltungen" element={<Veranstaltungen />} />
        <Route path="raeume" element={<Raeume />} />
        <Route path="raeume/:slug" element={<RaumDetail />} />
        <Route path="kontakt" element={<Kontakt />} />
        <Route path="partys/:eventSlug" element={<EventDetail />} />
        <Route path="partys" element={<Partys />} />
        <Route path="partys-karneval" element={<PartysKarneval />} />
        <Route path="brunch" element={<Brunch />} />
        <Route path="brunch/:brunchId" element={<BrunchDetail />} />
        <Route path="hochzeiten" element={<Hochzeiten />} />
        <Route path="unternehmensfeiern" element={<Unternehmensfeiern />} />
        <Route path="private-feiern" element={<PrivateFeiern />} />
        <Route path="galerie" element={<Galerie />} />
        <Route path="geschichte" element={<Geschichte />} />
        <Route path="buffets-angebote" element={<BuffetsAngebote />} />
        <Route path="foodtruck" element={<Foodtruck />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="impressum" element={<Impressum />} />
        <Route path="datenschutz" element={<Datenschutz />} />
        {/* 404 - Catch all - innerhalb des Layouts */}
        <Route path="*" element={<NotFound />} />
      </Route>
      
      {/* Dashboard Routes */}
      <Route path="/dashboard/login" element={<Suspense fallback={null}><DashboardLogin /></Suspense>} />
      <Route path="/dashboard/*" element={<Suspense fallback={null}><Dashboard /></Suspense>} />
    </Routes>
    </>
  )
}

export default App














